export default "__VITE_ASSET__LjNpq1lM__"